<template>
  <div class="footer">
    <div class="refresh">
      <div class="refresh-icon" :class="RefreshBtnStatus" @click="handleRefresh"></div>
      <template v-if="$bus.actInfo.payAllTimes > 0">
        <div class="refresh-info" v-if="$bus.actInfo.freeUsedTimes < $bus.actInfo.freeAllTimes">
          <p>{{$bus.transify['T_P_FREE_REFRESH']}}&nbsp;&nbsp;&nbsp;</p>
          <p class="refresh-nums"><span>{{$bus.actInfo.freeAllTimes - $bus.actInfo.freeUsedTimes}}</span>&nbsp;/&nbsp;{{$bus.actInfo.freeAllTimes}}</p>
        </div>
        <div class="refresh-info" v-else>
          <p class="refresh-cost">
            <i class="diamond"></i>
            <span class="gem-nums">{{$bus.actInfo.refreshCost}}</span>
          </p>
          <p>{{$bus.transify['T_P_REFRESH']}}:&nbsp;&nbsp;&nbsp;</p>
          <p class="refresh-nums"><span>{{$bus.actInfo.payAllTimes - $bus.actInfo.payUsedTimes || 0}}</span>&nbsp;/&nbsp;{{$bus.actInfo.payAllTimes || 0}}</p>
        </div>
      </template>
      <template v-if="$bus.actInfo.payAllTimes <= 0">
        <div class="refresh-info">
          <p>{{$bus.transify['T_P_FREE_REFRESH']}}&nbsp;&nbsp;&nbsp;</p>
          <p class="refresh-nums"><span>{{$bus.actInfo.freeAllTimes - $bus.actInfo.freeUsedTimes}}</span>&nbsp;/&nbsp;{{$bus.actInfo.freeAllTimes}}</p>
        </div>
      </template>
    </div>
    <div class="purchase">
      <div class="purchase-price" v-show="$bus.selects.length > 0 && !$bus.ComPool.status">
        <p class="new-price-inner">
          <i class="diamond"></i>
          <span class="new-price">{{getPrice}}</span>
        </p>
        <span class="old-price">{{getAllPrice}}</span>
      </div>
      <button class="purchase-btn" @click="handleBtn" :class="getPurchaseStatus">
        <p class="btn-text" v-show="!this.$bus.ComPool.status || !getRefreshStatus">{{$bus.transify['T_P_PURCHASE']}}</p>
        <p class="btn-text" v-show="this.$bus.ComPool.status && getRefreshStatus">
          <span>{{$bus.transify['T_P_REFRESH']}}</span>
          <span class="refresh-cost" v-show="$bus.actInfo.freeUsedTimes >= $bus.actInfo.freeAllTimes">
            <i class="diamond"></i>
            <span class="gem-nums">{{$bus.actInfo.refreshCost}}</span>
          </span>
        </p>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      nums: 12
    }
  },
  computed: {
    getPurchaseStatus () {
      if (this.$bus.selects.length > 0) {
        if (this.$bus.ComPool.status) { // 已经购买过
          let RefreshStatus = this.getRefreshStatus
          return RefreshStatus ? 'active' : ''
        } else {
          return 'active'
        }
      } else {
        return ''
      }
    },
    RefreshBtnStatus () {
      return this.$bus.ComPool.status && this.getRefreshStatus ? 'active' : !this.getRefreshStatus ? 'disabled' : ''
    },
    getRefreshStatus () {
      let [freeAllTimes, freeUsedTimes, payAllTimes, payUsedTimes] = [
        this.$bus.actInfo.freeAllTimes,
        this.$bus.actInfo.freeUsedTimes,
        this.$bus.actInfo.payAllTimes,
        this.$bus.actInfo.payUsedTimes
      ]
      if (freeAllTimes - freeUsedTimes <= 0) {
        if (payAllTimes - payUsedTimes <= 0) {
          return false
        } else {
          return true
        }
      } else {
        return true
      }
    },
    getAllPrice () {
      let allPrice = 0
      for (let item of this.$bus.selects) {
        allPrice += Number(item.price)
      }
      this.setAllPrice(allPrice)
      return allPrice
    },
    getPrice () {
      let price = 0
      for (let item of this.$bus.selects) {
        price += Math.floor(Number(item.price) * (100 - this.$bus.discount) / 100)
      }
      this.setPrice(price)
      return price
    }
  },
  methods: {
    setAllPrice (allPrice) {
      this.$bus.allPrice = allPrice
    },
    setPrice (price) {
      this.$bus.price = price
    },
    handleBtn () {
      if (this.$bus.ComPool.status) {
        if (this.getRefreshStatus) {
          this.handleRefresh()
        } else {
          return false
        }
      } else {
        if (this.$bus.selects.length < 1) {
          this.$bus.handleToast(true, 'T_P_CHOOSE_HINT')
        } else {
          this.handlePurchase()
        }
      }
    },
    handleRefresh () {
      // 判断状态
      let [freeAllTimes, freeUsedTimes, payAllTimes, payUsedTimes] = [
        this.$bus.actInfo.freeAllTimes,
        this.$bus.actInfo.freeUsedTimes,
        this.$bus.actInfo.payAllTimes,
        this.$bus.actInfo.payUsedTimes
      ]
      if (freeAllTimes - freeUsedTimes <= 0) { // 进入付费判断
        // 如果可付费刷新次数为0
        if (payAllTimes - payUsedTimes <= 0) {
          // 提示用户不可刷新
          this.$bus.handleToast(true, 'T_KU_REFRESH_CANT')
        } else {
          if (this.$bus.actInfo.refreshCost > this.$bus.gems) { // 没有足够钻石
            this.$bus.handleToast(true, 'T_P_ERR_LACK_OF_GEM')
            return false
          }
          // 弹出付费刷新确认弹窗 ----
          this.$bus.refreshDialog = {
            show: true,
            status: 1
          }
        }
      } else { // 进入免费刷新处理
        this.$bus.ComPool.status ? this.$bus.refresh(0) : this.$bus.refreshDialog = {show: true, status: 0}
      }
      this.$bus.addGA('refresh', 'click')
    },
    handlePurchase () {
      if (this.$bus.price > this.$bus.gems) { // 没有足够钻石
        this.$bus.handleToast(true, 'T_P_ERR_LACK_OF_GEM')
        return false
      }
      // 先判断是否会转化成token
      const ids = []
      for (let item of this.$bus.selects) {
        ids.push(item.id)
      }
      this.$api.confirm({reward_ids: ids}).then(res => {
        this.$bus.hasToken = res.data.is_token
        this.$bus.buy.show = true
      })
      // 展示确认弹窗 ----
      this.$bus.addGA('purchase_btn', 'click')
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  width: 100vw;
  @include px2res(height, 100);
  @include px2res(margin-top, 40);
  @include px2res(padding-left, 26);
  background-size: auto 100%;
  display: flex;
  justify-content: space-between;
  .refresh {
    @include flexrc;
    p {
      line-height: 1;
    }
    .refresh-icon {
      @include px2res(width, 142);
      @include px2res(height, 120);
      @include px2res(margin-top, -28);
    }
    .refresh-icon.active {
      animation: flash 1s ease-in-out infinite alternate;
    }
    .refresh-icon.disabled {
      filter: grayscale(100%);
      animation: none;
    }
    .refresh-info {
      @include flexrc;
      @include px2res(font-size, 28);
      @include px2res(padding, 0, 6);
      text-transform: uppercase;
      .refresh-nums {
        @include px2res(font-size, 36);
        font-style: italic;
        font-weight: 400;
        span {
          color: #FFDE00;
        }
      }
      .refresh-cost {
        @include flexrc;
        @include px2res(margin-right, 15);
        .diamond {
          @include px2res(width, 20.7);
          @include px2res(height, 18);
        }
        .gem-nums {
          font-weight: 500;
          @include px2res(margin-left, 5);
        }
      }
    }
  }
  .purchase {
    @include flexrc;
    justify-content: flex-end;
    @include px2res(width, 416);
    @include px2res(height, 100);
    position: relative;
    .purchase-price {
      white-space: nowrap;
      position: absolute;
      right: 100%;
      top: 50%;
      transform: translateY(-55%);
      @include px2res(font-size, 72);
      @include px2res(margin-right, 10);
      @include flexrc;
      align-items: flex-end;
      font-weight: 500;
      line-height: 1;
      .new-price-inner {
        @include flexrc;
        align-items: flex-end;
        animation: scale-bounce .3s ease-out both;
        transform-origin: bottom;
        position: relative;
        z-index: 1;
        .diamond {
          @include px2res(width, 39);
          @include px2res(height, 32);
          @include px2res(margin-right, 6);
        }
        .new-price {
          @include px2res(font-size, 88);
          @include px2res(height, 66);
          color: #FFDE00;
          @include px2res(margin-right, 20);
        }
      }
      .old-price {
        @include px2res(line-height, 46);
        position: relative;
      }
      .old-price::after {
        content: '';
        position: absolute;
        top: 38%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 106%;
        height: 1px;
        background: #FF0000;
      }
    }
    .purchase-btn {
      position: relative;
      @include px2res(width, 416);
      @include px2res(height, 100);
      @include px2res(font-size, 60);
      @include flexrc;
      @include px2res(padding, 0, 10, 0, 38);
      .btn-text {
        width: 100%;
        text-align: center;
        color:#0F0400;
        font-weight: 600;
        line-height: 1;
        @include px2res(height, 48);
        .refresh-cost {
          @include px2res(margin-left, 5);
          font-size: 0;
          .diamond {
            display: inline-block;
            @include px2res(width, 23.1);
            @include px2res(height, 20);
          }
          .gem-nums {
            @include px2res(font-size, 35);
            color: #0F0400;
            font-weight: 500;
            @include px2res(margin-left, 5);
          }
        }
      }
    }
    .purchase-btn.active {
      .btn-text {
        color:rgba(61, 11, 0, 1);
        text-shadow: 0px 2px 0px rgba(255, 246, 146, 1);
      }
      // animation: flash .8s ease-in-out infinite alternate;
    }
  }
}
@keyframes scale-bounce {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.3);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes flash {
  0% {
    filter: brightness(.9);
  }
  100% {
    filter: brightness(1.2);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Footer.vue